export default __webpack_public_path__ + "adf2800d3d0aa93662c2fa6aac9bb8ca.jpg";